import React, { useState, useEffect, useCallback, } from 'react';
import { QUESTION_VALUE_TYPE } from '../../../../constants/common';
import LabelItem from './label.item';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const LabelList = ({
  sample,
  labels,
  onLabelChange,
  onLabelIdOrderChange,
  labelIdOrders
}) => {
  const [labelList, setLabelList] = useState([]);

  useEffect(() => {
    if (!labels) return;
    const labelMaps = {};
    labels.forEach((label) => {
      labelMaps[label.id] = label.value;
    });
    setLabelList(labelMaps);
  }, [labels]);


  const moveCard = useCallback((result) => {
    if (!result.destination) {
      return;
    }
    const list = [...labelIdOrders];
    const [removedItem] = list.splice(result.source.index, 1);
    list.splice(result.destination.index, 0, removedItem);
    onLabelIdOrderChange(list);
  }, [labelIdOrders, onLabelIdOrderChange]);

  return <>
    {sample?.Data.valueType !== QUESTION_VALUE_TYPE.MULTIPLE && labels.length > 0 && (
      <div>
        <h4>Labels</h4>
        <DragDropContext onDragEnd={moveCard}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {labelIdOrders.map((id, index) => {
                  return <Draggable
                    key={index}
                    draggableId={`draggable-report-item-${index}`}
                    index={index}
                  >
                    {(draggableProvided) => (
                      <LabelItem
                        draggableProvided={draggableProvided}
                        moveCard={moveCard}
                        key={index}
                        label={{ id, value: labelList[id] }}
                        index={index}
                        onLabelChange={onLabelChange}
                      />
                    )}
                  </Draggable>
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div >
    )}</>
};

export default LabelList;
